export default {
  //generic
  SET_USER_OBJECT(state, payload) {
    state.config.userObject = payload;
  },

  SET_TOKEN(state, payload) {
    state.config.keycloak.token = payload;
  },

  SET_REFRESH_TOKEN(state, payload) {
    state.config.keycloak.refreshToken = payload;
  },

  SET_KEYCLOAK_OBJECT(state, payload) {
    state.config.keycloak.kc = payload;
  },

  SET_SNACKBAR(state, payload) {
    state.config.snackbar = payload;
  },

  SET_SHOW_LOADER(state, payload) {
    state.config.loader.show = payload.action;
    state.config.loader.text = payload.text;
  },

  SET_KC_EXPIRED_TOKEN_FN(state, value) {
    state.config.isTokenExpiredFn = value;
  },

  SET_CUSTOM_COMPONENT_CONFIG(state, payload) {
    state.config.customComponentsConfig = payload;
  },

  SET_CUSTOM_DASHBOARD_CONFIG(state, payload) {
    state.config.customDashboardConfig = payload;
  }
};
